export const ELLIPSIS = '&hellip;';
